import { ReactNode } from 'react';

import { Flex, Pill, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const CompletedRequirementItem = ({ title }: { title: ReactNode }) => {
    return (
        <Flex
            padding="container"
            gap="section"
            align="center"
            justify="between"
        >
            <Text className="text-m font-med text-primary-10">{title}</Text>
            <Pill variant="green">
                <FormattedMessage
                    id="_.funding_requirements_v2.status.completed"
                    defaultMessage="Completed"
                />
            </Pill>
        </Flex>
    );
};
